import {Component, EventEmitter, Input, Output} from '@angular/core';
import { ProjectService } from '../project/project.service';
import { Client } from '../model/client';
import {FormControl, FormGroup, Validators} from '@angular/forms';

/*
TODO : This component is void. It is unused. Remove upon confirmation
 */
@Component({

    selector: 'create-client-dialog',

    template: `<div class="modal" [style.display]="hide ? 'none' : 'inline'" style="margin : 20px; ">
    <div class="modal-dialog">
        <div class="modal-content">
            <!-- header-->
            <div class="modal-header">
              <h5 class="modal-title">New Client</h5>
              <button (click)="toggleDialog(); newClientForm.resetForm()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span class="closeX" aria-hidden="true">&times;</span>
              </button>
            </div>
            <form accept-charset="UTF-8" name="newClientForm" (ngSubmit)="newClientForm.form.valid && createClient() " #newClientForm="ngForm">
                <div *ngIf="errorCreatingClient" class="alert alert-danger">
                    <a href="#" class="close" data-dismiss="alert" aria-label="close" (click)="onClose()">&times;</a>
                    <strong>Error!</strong> has <a href="#" class="alert-link">occured while creating a client.</a>.
                </div>
                <div *ngIf="clientCreated" class="alert alert-success">
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    <strong>Success!</strong> client <a href="#" class="alert-link">created</a>.
                </div>
                <div class="modal-body">
                    <div class="row" style="margin-top:20px;">
                        <div class="col-md-4">
                            <label>Name</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" placeholder="Client Name" name="clientName" class="form-control" [(ngModel)]="_client.name" #clientName="ngModel"
                                required />
                            <div *ngIf="clientName.errors && (clientName.dirty || clientName.touched)"
                                class="alert alert-danger">
                                <div [hidden]="!clientName.errors.required">
                                    Name is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top:20px;">
                        <div class="col-md-4">
                            <label>Username </label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" placeholder="Username" name="username" class="form-control" [(ngModel)]="_client.username" #username="ngModel" required />
                            <div *ngIf="username.errors && (username.dirty || username.touched)"
                                class="alert alert-danger">
                                <div [hidden]="!username.errors.required">
                                    Username is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top:20px;">
                        <div class="col-md-4">
                            <label>Password </label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" placeholder="Password" name="password" class="form-control" [(ngModel)]="_client.password" #password="ngModel" required/>
                             <div *ngIf="password.errors && (password.dirty || password.touched)"
                                class="alert alert-danger">
                                <div [hidden]="!password.errors.required">
                                    Password is required
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- footer-->
                <div class="modal-footer ">
                    <button type="button" class="btn btn-primary clickable hand" id="submit" type="submit">{{'save'|translate}}</button>
                </div>
            </form>
        </div>
    </div>
</div>`,
    styles:[`
        .modal-dialog {
            width:50%;
            margin:auto;
        }
        .modal-header{
            background-color:dodgerblue;
            color:antiquewhite;
        }
        .closeX{color:azure;size:25px;}
        .close{background-color: red;height:60px;width:60px;z-index: +1;}`]

})
export class CreateClientComponent {

    private hide = true;
    private _client: Client = new Client();
    @Output() NewClient: EventEmitter<any> = new EventEmitter();
    private newClientForm:FormGroup;
    private clientCreated=false;
    private errorCreatingClient =  false;
    constructor(private _projectService: ProjectService) {
      this.newClientForm = new FormGroup({
        'clientName':new FormControl(this._client.name,[Validators.required]),
        'username':new FormControl(this._client.username,[Validators.required]),
        'password':new FormControl(this._client.password,[Validators.required])
      });
    }

    createClient() {
        this._projectService.createClient(this._client)
            .subscribe(data => {
                console.log(data);
                this.clientCreated=true;
                this.NewClient.emit();
            },
            error => {console.log('Error create client');this.errorCreatingClient=true;});
        this.toggleDialog();
    }


    toggleDialog() {
        this.newClientForm.reset();
        this._client = new Client();
        this.hide = !this.hide;
    }

  onClose() {
    this.errorCreatingClient=false;
    this.clientCreated=false;
  }
}
